import { FC, Fragment, useMemo } from "react";
import { CustomCellRendererProps } from "ag-grid-react";
import Stack from "@mui/material/Stack";
import { Chip, Popover, PopoverOrigin } from "@mui/material";
import { Schedule } from "@/services/cloudchipr.api";
import { ResourceServiceCell } from "@/components/pages/common/ag-grid/components/common-cell-renderers/ResourceServiceCell";
import { useMenuHook } from "@/utils/hooks/useMenu.hook";

export const WorkflowServiceCell: FC<CustomCellRendererProps<Schedule>> = ({
  data,
}) => {
  const { open, anchor, closeMenu, openMenu } = useMenuHook();
  const services = useMemo(
    () => data?.filter?.map((fil) => fil.filter.type),
    [data],
  );
  const firstService = services?.at(0);

  if (!services) {
    return "-";
  }

  return (
    <Stack direction="row" spacing={1} overflow="hidden" alignItems="center">
      {firstService && <ResourceServiceCell service={firstService} />}

      {services?.length > 1 && (
        <Fragment>
          <Chip
            label={`+${services.length - 1}`}
            onClick={openMenu}
            variant="outlined"
            size="small"
            sx={{ cursor: "pointer" }}
          />

          <Popover
            open={open}
            anchorEl={anchor}
            onClose={closeMenu}
            slotProps={slotProps}
            anchorOrigin={anchorOrigin}
            transformOrigin={transformOrigin}
          >
            <Stack spacing={1}>
              {services.map((service) => (
                <ResourceServiceCell
                  inPopover
                  service={service}
                  key={service}
                />
              ))}
            </Stack>
          </Popover>
        </Fragment>
      )}
    </Stack>
  );
};

const slotProps = {
  paper: {
    sx: {
      p: 1,
      maxHeight: "40dvh",
    },
  },
};

const anchorOrigin: PopoverOrigin = {
  vertical: "bottom",
  horizontal: "right",
};

const transformOrigin: PopoverOrigin = {
  vertical: "top",
  horizontal: "right",
};
